export default __webpack_public_path__ + "static/media/profile-header-blue.91ff8906.jpg";